import { render, staticRenderFns } from "./AddCreditsModal.vue?vue&type=template&id=19731dc5&scoped=true&"
import script from "./AddCreditsModal.vue?vue&type=script&lang=js&"
export * from "./AddCreditsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19731dc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19731dc5')) {
      api.createRecord('19731dc5', component.options)
    } else {
      api.reload('19731dc5', component.options)
    }
    module.hot.accept("./AddCreditsModal.vue?vue&type=template&id=19731dc5&scoped=true&", function () {
      api.rerender('19731dc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/AddCreditsModal.vue"
export default component.exports